// using nanoid() with the length of 5 for lower chances of having the same string values
// generate ids from https://nanoid.yuuniworks.com/ if needed
// from npm nanoid https://www.npmjs.com/package/nanoid

module.exports = {
    calendar: {
        FULL: 'XtLaP',
        PERSONAL: 'zH-MA',
        HR_OTPUK: 'plDuy',
        NORMATIVE_BTN: 'ZdLSa',
    },
    delivery: {
        PERSONAL: 'bhCvf',
        FULL: 'oWWu2',
        CAN_ADD: 'Rc7yg',
        CAN_ACCEPT: '9-iy1',
        // MAIL_NEW_REQUEST: 'Gma_t',
        // MAIL_CONFIRMED_REQUEST: 'MMIl_',
    },
    inquiry: {
        PERSONAL_INQUIRIES: 'tkS06',
        FULL_INQUIRIES: 'ifZlP',
        EXTERNAL_INQUIRY: 'eULDq',
        REPORTS: 'cPPwx',
        EQUIPMENTS: 'RpREC',
        INVENTORY: 'kO8vh',
        RENTED_MECHANIZATION: 'kHNU6',
        MATERIALS: 'FzJN5',
        ACTIVITIES: 'w3NQy',
        WORKERS: 'GZGOz',
        BALANCE: 'l9NR5',
        PLANNED_EXECUTED: 'VX_aN',
    },
    reports: {
        PLANNING: "ei_m4",
        REPORTING: "YoRNK",
        WORKER_SECTION: "Fqh4G",
        EQUIPMENTS_SECTION: "EDGHI",
        INVENTORY_SECTION: "46mHV",
        RENTED_MECHANIZATION_SECTION: "cTpYo",
        MATERIALS_SECTION: "eK9qA",
        ACTIVITIES_SECTION: "K-18A",
        PRICES: "mLube",
        SELF_REPORTS: "4gDRd",
        SELF_REPORTS_GROUPS: "iBXiU",
        ACCEPT_WORKER_REPORTS: "ODBFz",
        ACCEPT_OWN_PROJECT_REPORTS: "1yxJE",
    },
    inventory: {
        TOOLS_OWN: "0_w9Z",
        TOOLS__ALL: "eFld9",
        MECHANIZATIONS_OWN: "3eimT",
        MECHANIZATIONS_ALL: "BZARa",
        HEAVY_MACHINERY_OWN: "4xnxv",
        HEAVY_MACHINERY_ALL: "IB3Fr",
        HEAVY_MACHINERY_MAILS: "U4vnQ",
        HEAVY_MACHINERY_INQUIRY: "KlSoz",
        LPS_OWN: "5mzOS",
        LPS_ALL: "YVbDV",
        LPS_RETURNED_ON: "xZHVI",
        LPS_SCRAPPED_ON: "Dn_TN",
        PERNIK_OWN: "rjeTe",
        PERNIK_ALL: "AwbE_",
        CAR_OWN: "Kuzrv",
        CAR_ALL: "ojUwm",
        CAR_MAILS: "JqRXu",
        CAR_INQUIRY: "QpLk2",
    },
    users: {
        USERS_INFO: "r-dMC",
        USERS_INVENTORY_OWN: "_K97X",
        USERS_INVENTORY_ALL: "YGJ17",
        USERS_ROLES: "IQbAf",
    },
    companies: {
        COMPANIES_PROJECTS: 'iJpsT',
        MECHANIZATION_TAB: 'QuML6',
        PRODUCTION_TAB: '9PtVl',
        CONSTRUCTION_TAB: '_0mv-',
    },
    log: {
        LOG: '6XNFn'
    },
};
